import { useEffect } from 'react';
import { scrollTop } from '@/helpers/utils';
import { Pagination } from '@/components/Pagination';
import { useGetPortfolioMovementsList } from '@/query/queries/report/useGetPortfolioMovementsList';
import { useWindowSize } from '@/hooks/useWindowSize';
import { Table } from './table';
import { List } from './list';
import s from './index.module.scss';

export const DataView = ({ params, setParams }) => {
  const { isMobile } = useWindowSize();
  const { data, isLoading } = useGetPortfolioMovementsList({
    page: params.page,
    date_from: params.range[0],
    date_to: params.range[1],
    operation_types: params.operation_types,
    grouping: JSON.stringify(params.grouping),
  });

  useEffect(() => {
    scrollTop();
  }, [params.page]);

  return (
    <div className={s.wrapper}>
      {isMobile ? (
        <List isLoading={isLoading} data={data} grouping={params.grouping} />
      ) : (
        <Table isLoading={isLoading} data={data} grouping={params.grouping} />
      )}

      {data?.total_pages > 0 && (
        <Pagination
          currentPage={params.page - 1}
          totalPages={data?.total_pages}
          onPageChange={({ selected }) =>
            setParams(prev => ({ ...prev, page: selected + 1 }))
          }
        />
      )}
    </div>
  );
};
